module.exports = __webpack_public_path__ + "static/media/tinywow_2433AmbrosiaBlüteale_colored_55475405.352fb0e1.jpg";